
	export default {
		data() {
			return {
				tabs: ['Skill Level', 'By Genre', 'By Instrument', 'Learning Paths'],
				current: 0,
				instrumentModal: false,
				currentInstrument: false,
				currentType: false,
				currentValue: false
			}
		},
		methods: {
			openInstrumentModal(inputType, inputValue){
				this.currentType = inputType
				this.currentValue = inputValue
				this.instrumentModal = true
			},
			doInstrumentSearch(inputInstrument){
				if(inputInstrument){
					window.open(
						`/search?tagsearch=true&instrument=${encodeURIComponent(inputInstrument.toLowerCase())}`,
						'_blank').focus()
				} else if(this.currentInstrument){
					window.open(
						`/search?tagsearch=true&${encodeURIComponent(this.currentType.toLowerCase())}=${encodeURIComponent(this.currentValue.toLowerCase())}&instrument=${encodeURIComponent(this.currentInstrument.toLowerCase())}`,
						'_blank').focus()
				}
			}
		},
		watch: {
			instrumentModal(){
				this.currentInstrument = false
			}
		}
	}
